import * as React from "react";
import ModalBase from "../ModalBase";
import { CheckMarkCircle } from "../../icons";
import styles from "./index.module.css";

const SuccessModal = ({ isOpen, onClose, title }) => {

    return (
        <ModalBase isOpen={isOpen} onClose={onClose} title={"Transaction Receipt"}>
            <div className={styles["payment-success-container"]}>
                <CheckMarkCircle className={styles["payment-success-icon"]} />
                {/* <div className={styles["payment-success-title">Payment Successful</div> */}
                <div className={styles["payment-success-body"]}>
                    <span className={styles["payment-success-body-text"]}>
                        {title}
                    </span>
                </div>
                <div className={styles["payment-success-footer"]}>
                    <div className={styles["payment-success-footer-button"]}>

                    </div>
                    <div className={`${styles["payment-success-footer-button"]} ${styles["outlined"]}`} onClick={onClose}>
                        Close
                    </div>
                </div>
            </div>
        </ModalBase>
    );
};

export default SuccessModal;
